module.exports = __webpack_public_path__ + "static/img/tetuko_no_heya_logo.b031f39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/tetuko_no_heya_logo.png
// module id = yz9/
// module chunks = 0